import { bandWeightOptions, buildHomeBandWeightAndColor } from 'fitbeat.gym-core';
import React from 'react';
import { StyleSheet, Text, View } from 'react-native';
import theme from '../theme';
import { defaultScale, scaleText } from '../utils/scaling';

const BandCollection = () => {
  return (
    <View style={styles.container}>
      {bandWeightOptions.map((option) => {
        const { color } = buildHomeBandWeightAndColor(option);
        const overrideStyle = option === 'MEDIUM';
        return (
          <View
            style={[
              styles.band,
              { backgroundColor: color },
              overrideStyle && { height: defaultScale(30), width: '160%', opacity: 1 },
            ]}
          >
            <Text
              style={[
                styles.bandText,
                overrideStyle && { fontSize: scaleText(16) },
              ]}
            >
              {option}
            </Text>
          </View>
        );
      })}
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    padding: defaultScale(10),
    backgroundColor: theme.WHITE,
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: defaultScale(10),
    shadowColor: theme.BLACK,
    shadowOffset: {
      width: 0,
      height: defaultScale(3.5),
    },
    shadowOpacity: 0.2,
    shadowRadius: defaultScale(15),
    elevation: 5,
  },
  band: {
    height: defaultScale(18),
    width: defaultScale(104),
    marginBottom: defaultScale(5),
    justifyContent: 'center',
    alignItems: 'center',
    opacity: 0.5,
  },
  bandText: {
    color: theme.WHITE,
    fontSize: scaleText(10),
    fontFamily: theme.Custom800,
  },
});

export default BandCollection;
